var exports = {
  "i": "x936d19a0--575d66--wrapper",
};

module.exports = exports;
